import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useParams } from 'react-router-dom';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { useUpdateInvoiceTaskAccountingConfirmed } from '@/hooks/api/1971_update_invoice_task_accounting_confirmed';
import React, { useEffect, useState } from 'react';
import { toastApiError } from '@/lib/toast';

export const AccountingConfirmationCheck = ({ disabled }: { disabled: boolean }) => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { sales_order_id } = useParams();
  const { invoiceTask: task } = useCurrentInvoiceTask();
  const { mutate, data, isPending, isSuccess, error } = useUpdateInvoiceTaskAccountingConfirmed();
  const [checked, setChecked] = useState<boolean>(task!.accounting_confirmed);

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  const onCheck = (e: React.ChangeEvent) => {
    task!.accounting_confirmed = !task!.accounting_confirmed;
    setChecked((_) => task!.accounting_confirmed);

    setShowLoading(true);
    mutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: Number(sales_order_id),
      task_id: task!.id,
      accounting_confirmed: task!.accounting_confirmed,
    });
  };

  return (
    <div
      className={`checklist-item ps-2 ms-3 ${
        task!.accounting_confirmed ? 'checklist-item-success' : 'checklist-item-danger'
      }`}
    >
      <div>
        <h6 className="mb-0 text-dark font-weight-bold text-sm">
          管理会計確認
          {task!.accounting_confirmed ? <></> : <i className="fas fa-exclamation-circle ms-1 text-danger"></i>}
        </h6>
        <div className="text-weak text-xs mt-1 lh-base">
          このタスクに紐づくプロジェクトは管理会計とタスクが連動していません。
          <br />
          経理担当者に確認を取ってください。
        </div>
      </div>

      <div className="form-check mt-3">
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="payment-task-accounting-confirmed"
          checked={task!.accounting_confirmed}
          onChange={onCheck}
          disabled={disabled}
        />
        <label className="custom-control-label" htmlFor="payment-task-accounting-confirmed">
          経理担当者へ管理会計金額が適切なことを確認
        </label>
      </div>
    </div>
  );
};
